(() => {
  if (window.nerivaFlowPTR2Installed) return;
  window.nerivaFlowPTR2Installed = true;
  const initialise = root => {
    if (root.dataset.nrReady === 'pt-r2') return;
    root.nrFlowCleanup?.();
    root.dataset.nrReady = 'pt-r2';
    root.classList.add('nx-enhanced', 'nx-demo-motion', 'flow-motion-enabled');
    root.classList.remove('nx-paused');
    const controller = new AbortController();
    const on = (target, event, listener, options = {}) => target.addEventListener(event, listener, { ...options, signal: controller.signal });
    const hero = root.querySelector('.flow-hero');
    const scenes = [...root.querySelectorAll('.flow-scene')];
    const tabs = [...root.querySelectorAll('[data-scene]')];
    const panels = [...root.querySelectorAll('.flow-panel')];
    const journey = root.querySelector('.flow-journey');
    const track = root.querySelector('.flow-journey-track');
    const pin = root.querySelector('.flow-journey-pin');
    const intro = root.querySelector('.flow-intro');
    const ink = [...root.querySelectorAll('[data-ink]')];
    let current = 0, timer = null, warmTimer = null, frame = 0, heroVisible = true, heroReady = false, request = 0;
    const clamp = value => Math.max(0, Math.min(1, value));
    const loading = new WeakMap();
    const loadPicture = picture => {
      if (!picture) return Promise.resolve(false);
      if (loading.has(picture)) return loading.get(picture);
      const img = picture.querySelector('img');
      const promise = (async () => {
        // Set the matching source first, so a phone never requests the desktop fallback.
        picture.querySelectorAll('source[data-srcset]').forEach(source => { source.srcset = source.dataset.srcset; });
        if (img.dataset.src) img.src = img.dataset.src;
        try {
          await img.decode();
          if (controller.signal.aborted || !img.naturalWidth) return false;
          picture.classList.add('nr-loaded');
          return true;
        } catch {
          loading.delete(picture); // A later interaction may retry a failed request.
          return false;
        }
      })();
      loading.set(picture, promise);
      return promise;
    };
    const warmNext = () => {
      clearTimeout(warmTimer);
      if (heroVisible && !document.hidden) warmTimer = setTimeout(() => {
        loadPicture(scenes[(current + 1) % scenes.length].querySelector('picture'));
      }, 2500);
    };
    const show = async index => {
      const next = (index + scenes.length) % scenes.length;
      const ticket = ++request;
      const ready = await loadPicture(scenes[next].querySelector('picture'));
      // Keep the currently decoded photograph visible on a slow connection.
      if (!ready || controller.signal.aborted || ticket !== request) return;
      current = next;
      scenes.forEach((scene, i) => scene.classList.toggle('is-active', i === current));
      tabs.forEach((tab, i) => tab.setAttribute('aria-pressed', String(i === current)));
      root.querySelector('[data-scene-label]').textContent = tabs[current].dataset.label;
      warmNext();
    };
    const schedule = () => {
      clearInterval(timer); clearTimeout(warmTimer);
      if (heroReady && heroVisible && !document.hidden) {
        timer = setInterval(() => show(current + 1), 6500);
        warmNext();
      }
    };
    const loadPanel = index => loadPicture(panels[index]?.querySelector('picture'));
    const paint = () => {
      frame = 0;
      const box = journey.getBoundingClientRect();
      const progress = clamp(-box.top / Math.max(1, box.height - innerHeight));
      pin.scrollLeft = 0;
      track.style.transform = `translate3d(${-progress * 66.6666667}%,0,0)`;
      journey.style.setProperty('--flow-progress', progress);
      if (box.top < innerHeight + 400 && box.bottom > -400) {
        const index = Math.min(2, Math.floor(progress * 2));
        loadPanel(index); loadPanel(Math.min(2, index + 1));
      }
      const start = intro.getBoundingClientRect().top;
      ink.forEach((element, i) => element.style.setProperty('--ink', clamp((innerHeight - start) / innerHeight * 1.7 - i * .35)));
    };
    const requestPaint = () => { if (!frame) frame = requestAnimationFrame(paint); };
    const measureShell = () => {
      const top = root.getBoundingClientRect().top + scrollY;
      root.style.setProperty('--nr-shell-height', `${Math.max(0, Math.min(240, top))}px`);
      requestPaint();
    };
    tabs.forEach(tab => on(tab, 'click', () => { show(Number(tab.dataset.scene)); schedule(); }));
    on(document, 'visibilitychange', schedule);
    let touchStart = 0;
    on(hero, 'touchstart', event => { touchStart = event.touches[0].clientX; }, { passive: true });
    on(hero, 'touchend', event => {
      const delta = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(delta) > 60) { show(current + (delta < 0 ? 1 : -1)); schedule(); }
    }, { passive: true });
    on(journey, 'focusin', event => {
      const panel = event.target.closest('.flow-panel'); if (!panel) return;
      const index = panels.indexOf(panel);
      scrollTo({ top: journey.getBoundingClientRect().top + scrollY + index / 2 * (journey.offsetHeight - innerHeight), behavior: 'instant' });
      requestPaint();
    });
    on(window, 'scroll', requestPaint, { passive: true });
    on(window, 'resize', measureShell);
    const visibility = 'IntersectionObserver' in window ? new IntersectionObserver(entries => { heroVisible = entries[0].isIntersecting; schedule(); }) : null;
    visibility?.observe(hero);
    const resize = 'ResizeObserver' in window ? new ResizeObserver(measureShell) : null;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(element => resize?.observe(element));
    root.nrFlowCleanup = () => {
      controller.abort(); visibility?.disconnect(); resize?.disconnect();
      clearInterval(timer); clearTimeout(warmTimer); cancelAnimationFrame(frame); request++;
    };
    measureShell();
    // Start the countdown after the first photograph has decoded, without blocking its eager request.
    loadPicture(scenes[0].querySelector('picture')).then(() => {
      if (!controller.signal.aborted) { heroReady = true; schedule(); }
    });
  };
  const load = scope => {
    if (scope.matches?.('[data-neriva-flow]')) initialise(scope);
    scope.querySelectorAll('[data-neriva-flow]').forEach(initialise);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => load(document), { once: true });
  else load(document);
  document.addEventListener('shopify:section:load', event => load(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-neriva-flow]').forEach(root => root.nrFlowCleanup?.()));
})();
